import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5001/api';

/**
 * Generated requirement structure from API
 */
export interface GeneratedRequirement {
  title: string;
  description: string;
  acceptance_criteria?: string;
  requirement_type: 'functional' | 'non_functional' | 'business' | 'technical';
  priority: 'critical' | 'high' | 'medium' | 'low';
  category: string;
}

/**
 * Input for generating requirements
 */
export interface GenerateRequirementsInput {
  projectId?: string;
  projectType: string;
  projectName: string;
  projectDescription: string;
  inScope?: string;
  outScope?: string;
  startDate?: string;
  endDate?: string;
  seedingSize?: 'small' | 'medium' | 'large';
}

/**
 * Result of requirement generation
 */
export interface RequirementGenerationResult {
  requirements: GeneratedRequirement[];
  source: 'ai' | 'template';
  tokensUsed?: number;
  model?: string;
  error?: string;
}

/**
 * Generate requirements for a new project using AI with template fallback
 *
 * @param input - Project details for context
 * @param token - JWT authentication token
 * @returns Generated requirements with metadata
 */
export async function generateRequirements(
  input: GenerateRequirementsInput,
  token: string
): Promise<RequirementGenerationResult> {
  const response = await axios.post(
    `${API_BASE}/requirements/generate`,
    input,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );

  return response.data.data;
}

/**
 * Get template requirements for a specific project type (for preview)
 *
 * @param projectType - Project type name
 * @param token - JWT authentication token
 * @returns Array of template requirements
 */
export async function getTemplateRequirements(
  projectType: string,
  token: string
): Promise<GeneratedRequirement[]> {
  const response = await axios.get(
    `${API_BASE}/requirements/templates/${encodeURIComponent(projectType)}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data.data.requirements;
}
